// Snellife pagina prodotto: barra d'acquisto fluttuante, prodotti consigliati, stile del pulsante Releasit.
(() => {
  const productInfo = document.querySelector('product-info');

  // Releasit inserisce "Paga alla consegna" con stili inline !important: li riallineo allo stile del sito.
  const styleCashOnDelivery = () => {
    const button = productInfo?.querySelector('#_rsi-buy-now-button');
    if (!button || button.dataset.snlStyled) return;
    button.dataset.snlStyled = 'true';
    const set = (property, value) => button.style.setProperty(property, value, 'important');
    set('background', '#1f6b42');
    set('color', '#ffffff');
    set('border-radius', '999px');
    set('box-shadow', 'none');
    set('min-height', '5.2rem');
    set('font-size', '1.5rem');
  };

  const findMainButton = () => productInfo?.querySelector('.product-form__submit');

  const readPrice = () => {
    const price = productInfo?.querySelector('.price');
    if (!price) return '';
    const current = price.classList.contains('price--on-sale')
      ? price.querySelector('.price__sale .price-item--sale')
      : price.querySelector('.price__regular .price-item--regular');
    return current ? current.textContent.trim() : '';
  };

  // Barra d'acquisto fluttuante: compare quando il pulsante principale esce dallo schermo verso l'alto
  const bar = document.querySelector('[data-snl-sticky]');
  if (bar && productInfo && findMainButton()) {
    const barPrice = bar.querySelector('[data-snl-sticky-price]');
    const barButton = bar.querySelector('[data-snl-sticky-add]');
    const barLabel = barButton?.textContent.trim() || '';

    const sync = () => {
      const mainButton = findMainButton();
      if (barPrice) barPrice.textContent = readPrice();
      if (barButton && mainButton) {
        barButton.disabled = mainButton.disabled;
        barButton.textContent = mainButton.disabled ? 'Esaurito' : barLabel;
      }
    };

    const observer = new IntersectionObserver(([entry]) => {
      const visible = !entry.isIntersecting && entry.boundingClientRect.top < 0;
      bar.classList.toggle('is-visible', visible);
      bar.setAttribute('aria-hidden', String(!visible));
      if (barButton) barButton.tabIndex = visible ? 0 : -1;
      document.body.classList.toggle('snl-sticky-on', visible);
    });
    observer.observe(findMainButton());

    barButton?.addEventListener('click', () => {
      const mainButton = findMainButton();
      if (mainButton && !mainButton.disabled) mainButton.click();
    });

    sync();
    new MutationObserver(() => {
      sync();
      styleCashOnDelivery();
    }).observe(productInfo, { childList: true, subtree: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  }

  styleCashOnDelivery();

  // Prodotti consigliati da Shopify, caricati dopo la pagina
  const reco = document.querySelector('[data-snl-reco]');
  if (reco?.dataset.url) {
    const block = reco.closest('.sh-block');
    fetch(reco.dataset.url)
      .then((response) => response.text())
      .then((html) => {
        const fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-snl-reco]');
        if (fresh && fresh.querySelector('.sh-product')) {
          reco.innerHTML = fresh.innerHTML;
          block?.classList.remove('sh-pp-reco__empty');
        } else {
          block?.remove();
        }
      })
      .catch(() => block?.remove());
  }
})();
